// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Ri-z","srOnly":"Si-z"};